export const ocplcDashboard = `query {
  ocplcDashboard {
    ocplcProductModels {
      kmatId
      productLineID
      productLineName
      manufacturingName
      productGroup
      status
      author
      lastModifiedTS
    }
    ocplcProductLines {
      id
      name
      count
    }
    statuses
  }
}`